import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import style from '../style.module.less';

export const LineItemAdjustmentNotice = () => (
  <div className={style['line-item-adjustment-notice']}>
    <FontAwesomeIcon className={style['notice-svg']} icon={faInfoCircle} />
    <FormattedMessage
      defaultMessage='Selling channel adjusted quantity'
      description='line item message alerting customer about a change'
      id='Hv4pod'
    />
  </div>
);
